"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isShallowEqual(paramA, paramB) {
    var keysA = Object.keys(paramA);
    var keysB = Object.keys(paramB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(paramB, keysA[i]) || paramA[keysA[i]] !== paramB[keysA[i]]) {
            return false;
        }
    }
    return true;
}
exports.default = isShallowEqual;
//# sourceMappingURL=isShallowEqual.js.map